import { useState } from 'react'
import Layout from '../../components/Layout'
import api from '../../services/api'
import './style.css'

/**
 * ProfitLoss Component
 * 
 * Page for viewing profit and loss reports with filters and export options.
 */
function ProfitLoss() {
  const [entriesPerPage] = useState(25)
  const [currentPage] = useState(1)
  const [searchValue, setSearchValue] = useState('')
  const [filterType, setFilterType] = useState('All')
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)

  // Handle Load button click
  const handleLoad = async () => {
    setLoading(true)
    try {
      const response = await api.get('/admin/pl/all', {
        params: {
          page: 1, // Reset to page 1 on load
          limit: entriesPerPage,
          search: searchValue
        }
      })
      
      if (response.data.success) {
        setTableData(response.data.data)
      } else {
        setTableData([])
      }
    } catch (error) {
      console.error('Error loading data:', error)
      setTableData([])
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout title="Profit Loss - Diamond Admin">
      <div className="listing-grid">
        <div className="account-list-statement">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">
                  Profit Loss
                </h4>
              </div>
            </div>
          </div>

        <div className="card">
      <div className="card-body-casino">
                {/* Filter Form */}
                <div className="row">
            <div className="col-12">
              <div className="">
                <div className="">
                  <form method="post" className="ajaxFormSubmit" onSubmit={(e) => { e.preventDefault(); handleLoad(); }}>
                    <div className="row row5">
                      <div className="col-md-2">
                        <select 
                          className="form-control"
                          value={filterType}
                          onChange={(e) => setFilterType(e.target.value)}
                        >
                          <option value="All">All</option>
                          <option value="Dealer">Dealer</option>
                          <option value="Agent">Agent</option>
                          <option value="Client">Client</option>
                        </select>
                      </div>
                      <div className="col-md-2 d-flex align-items-end">
                        <button type="submit" className="btn btn-primary">
                          Load
                        </button>
                      </div>
                      <div className="col-md-8 d-flex align-items-end justify-content-end">
                        <div id="tickets-table_filter" className="dataTables_filter">
                          <label className="d-inline-flex align-items-center">
                            Search:
                            <input 
                              name="search" 
                              type="search" 
                              placeholder="Search..." 
                              className="form-control form-control-sm ml-2 form-control py-1"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="row">
            <div className="col-12">
              <div className="">
                <div className="">
                  {/* Table */}
                  <div className="table-responsive mb-0 mt-4">
                    <div className="table no-footer table-responsive-sm">
                      <table 
                        id="profitLossTbl" 
                        role="table" 
                        aria-busy={loading}
                        aria-colcount="7"
                        className="table b-table table-striped table-bordered"
                      >
                        <thead role="rowgroup" className="">
                          <tr role="row" className="">
                            <th role="columnheader" scope="col" aria-colindex="1" className="position-relative"><div>No</div></th>
                            <th role="columnheader" scope="col" aria-colindex="2" className="position-relative"><div>User Name</div></th>
                            <th role="columnheader" scope="col" aria-colindex="3" className="position-relative"><div>Level</div></th>
                            <th role="columnheader" scope="col" aria-colindex="4" className="position-relative text-right"><div>Casino Pts</div></th>
                            <th role="columnheader" scope="col" aria-colindex="5" className="position-relative text-right"><div>Sport Pts</div></th>
                            <th role="columnheader" scope="col" aria-colindex="6" className="position-relative text-right"><div>Third Party Pts</div></th>
                            <th role="columnheader" scope="col" aria-colindex="7" className="position-relative text-right"><div>Profit/Loss</div></th>
                          </tr>
                        </thead>
                        <tbody role="rowgroup">
                          {loading ? (
                            <tr role="row" className="b-table-empty-row">
                              <td colSpan="7" role="cell" className="">
                                <div role="alert" aria-live="polite">
                                  <div className="text-center my-2">Loading...</div>
                                </div>
                              </td>
                            </tr>
                          ) : tableData.length === 0 ? (
                            <tr role="row" className="b-table-empty-row">
                              <td colSpan="7" role="cell" className="">
                                <div role="alert" aria-live="polite">
                                  <div className="text-center my-2">No data available in table</div>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            tableData.map((row, index) => (
                              <tr key={row.wallet_id || index} role="row" className="">
                                <td aria-colindex="1" role="cell" className="">
                                  {(currentPage - 1) * entriesPerPage + index + 1}
                                </td>
                                <td aria-colindex="2" role="cell" className="">
                                  {row.username || '-'}
                                </td>
                                <td aria-colindex="3" role="cell" className="">
                                  {row.level || '-'}
                                </td>
                                <td aria-colindex="4" role="cell" className="text-right">
                                  {row.casino_pts || '0.00'}
                                </td>
                                <td aria-colindex="5" role="cell" className="text-right">
                                  {row.sport_pts || '0.00'}
                                </td>
                                <td aria-colindex="6" role="cell" className="text-right">
                                  {row.third_party_pts || '0.00'}
                                </td>
                                <td aria-colindex="7" role="cell" className={`text-right ${parseFloat(row.profit_loss) >= 0 ? 'text-success' : 'text-danger'}`}>
                                  {row.profit_loss || '0.00'}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Pagination */}
                  <div className="row pt-3">
                    <div className="col">
                      <div className="dataTables_paginate paging_simple_numbers float-right">
                        <ul className="pagination pagination-rounded mb-0">
                          <ul 
                            role="menubar" 
                            aria-label="Pagination" 
                            className="pagination dataTables_paginate paging_simple_numbers my-0 b-pagination justify-content-end"
                          >
                            <li role="presentation" className="page-item disabled">
                              <span role="menuitem" aria-label="Go to first page" className="page-link">«</span>
                            </li>
                            <li role="presentation" className="page-item disabled">
                              <span role="menuitem" aria-label="Go to previous page" className="page-link">‹</span>
                            </li>
                            <li role="presentation" className="page-item active">
                              <button 
                                role="menuitemradio" 
                                type="button" 
                                aria-label="Go to page 1" 
                                className="page-link"
                              >
                                1
                              </button>
                            </li>
                            <li role="presentation" className="page-item disabled">
                              <span role="menuitem" aria-label="Go to next page" className="page-link">›</span>
                            </li>
                            <li role="presentation" className="page-item disabled">
                              <span role="menuitem" aria-label="Go to last page" className="page-link">»</span>
                            </li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
        </div>
        </div>
      </div>
    </Layout>
  )
}

export default ProfitLoss

